var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 501,
    viewBox: "0 0 501 501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11181_233267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.278 147.199C498.078 120.599 493.778 102.399 487.678 86.4989C481.278 70.0989 472.778 56.0989 458.878 42.2989C444.978 28.4989 431.078 19.7989 414.678 13.4989C398.778 7.29893 380.578 3.09893 353.978 1.89893C327.278 0.698926 318.778 0.398926 250.978 0.398926C183.078 0.398926 174.578 0.698926 147.978 1.89893C121.378 3.09893 103.178 7.39893 87.2784 13.4989C70.7784 19.8989 56.7784 28.3989 42.9784 42.2989C29.1784 56.1989 20.4784 70.0989 14.1784 86.4989C8.07837 102.399 3.77837 120.599 2.57837 147.199C1.37837 173.899 1.07837 182.399 1.07837 250.199C1.07837 318.099 1.37837 326.599 2.57837 353.199C3.77837 379.799 8.07837 397.999 14.1784 413.899C20.5784 430.299 29.0784 444.299 42.9784 458.099C56.7784 471.999 70.7784 480.599 87.1784 486.899C103.078 493.099 121.278 497.299 147.878 498.499C174.578 499.699 183.078 499.999 250.878 499.999C318.778 499.999 327.278 499.699 353.878 498.499C380.478 497.299 398.678 492.999 414.578 486.899C430.978 480.499 444.978 471.999 458.778 458.099C472.578 444.199 481.278 430.299 487.578 413.899C493.778 397.999 497.978 379.799 499.178 353.199C500.378 326.499 500.678 317.999 500.678 250.199C500.678 182.399 500.478 173.799 499.278 147.199ZM454.378 351.199C453.278 375.599 449.178 388.899 445.778 397.599C441.278 409.199 435.778 417.599 426.978 426.399C418.178 435.199 409.878 440.499 398.178 445.199C389.378 448.599 376.078 452.699 351.778 453.799C325.478 454.999 317.578 455.299 250.778 455.299C183.978 455.299 176.078 454.999 149.778 453.799C125.378 452.699 112.078 448.599 103.378 445.199C91.7784 440.699 83.3784 435.199 74.5784 426.399C65.7784 417.599 60.4784 409.299 55.7784 397.599C52.3784 388.799 48.2784 375.499 47.1784 351.199C45.9784 324.899 45.6784 316.999 45.6784 250.199C45.6784 183.399 45.9784 175.499 47.1784 149.199C48.2784 124.799 52.3784 111.499 55.7784 102.799C60.2784 91.1989 65.7784 82.7989 74.5784 73.9989C83.3784 65.1989 91.6784 59.8989 103.378 55.1989C112.178 51.7989 125.478 47.6989 149.778 46.5989C176.078 45.3989 183.978 45.0989 250.778 45.0989C317.578 45.0989 325.478 45.3989 351.778 46.5989C376.178 47.6989 389.478 51.7989 398.178 55.1989C409.778 59.6989 418.178 65.1989 426.978 73.9989C435.778 82.7989 441.078 91.0989 445.778 102.799C449.178 111.599 453.278 124.899 454.378 149.199C455.578 175.499 455.878 183.399 455.878 250.199C455.878 316.999 455.478 324.899 454.378 351.199Z",
    fill: "url(#paint0_linear_11181_233267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.778 121.799C179.778 121.799 122.378 179.299 122.378 250.199C122.378 321.199 179.878 378.599 250.778 378.599C321.678 378.599 379.178 320.999 379.178 250.199C379.178 179.199 321.778 121.799 250.778 121.799ZM250.778 333.499C204.778 333.499 167.478 296.199 167.478 250.199C167.478 204.199 204.778 166.899 250.778 166.899C296.778 166.899 334.078 204.199 334.078 250.199C334.078 296.199 296.778 333.499 250.778 333.499Z",
    fill: "url(#paint1_linear_11181_233267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.178 146.799C400.747 146.799 414.178 133.367 414.178 116.799C414.178 100.23 400.747 86.7988 384.178 86.7988C367.61 86.7988 354.178 100.23 354.178 116.799C354.178 133.367 367.61 146.799 384.178 146.799Z",
    fill: "#BC30A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.77832 250.199C0.77832 318.099 1.07832 326.599 2.27832 353.199C3.47832 379.799 7.77832 397.999 13.8783 413.899C20.2783 430.299 28.7783 444.299 42.6783 458.099C56.4783 471.899 70.4783 480.599 86.8783 486.899C102.778 493.099 120.978 497.299 147.578 498.499C174.278 499.699 182.778 499.999 250.578 499.999C318.478 499.999 326.978 499.699 353.578 498.499C380.178 497.299 398.378 492.999 414.278 486.899C430.678 480.499 444.678 471.999 458.478 458.099C472.278 444.299 480.978 430.299 487.278 413.899C493.478 397.999 497.678 379.799 498.878 353.199C500.078 326.499 500.378 317.999 500.378 250.199C500.378 182.299 500.078 173.799 498.878 147.199C497.678 120.599 493.378 102.399 487.278 86.4989C480.878 70.0989 472.378 56.0989 458.478 42.2989C444.778 28.3989 430.778 19.7989 414.378 13.4989C398.478 7.29893 380.278 3.09893 353.678 1.89893C326.978 0.698926 318.478 0.398926 250.678 0.398926C182.778 0.398926 174.278 0.698926 147.678 1.89893C121.078 3.09893 102.878 7.39893 86.9783 13.4989C70.5783 19.8989 56.5783 28.3989 42.7783 42.2989C28.9783 56.1989 20.2783 70.0989 13.9783 86.4989C7.77832 102.399 3.47832 120.599 2.27832 147.199C1.07832 173.799 0.77832 182.299 0.77832 250.199ZM45.8783 250.199C45.8783 183.499 46.1783 175.499 47.3783 149.199C48.4783 124.799 52.5783 111.499 55.9783 102.799C60.4783 91.1989 65.9783 82.7989 74.7783 73.9989C83.5783 65.1989 91.8783 59.8989 103.578 55.1989C112.378 51.7989 125.678 47.6989 149.978 46.5989C176.278 45.3989 184.178 45.0989 250.978 45.0989C317.778 45.0989 325.678 45.3989 351.978 46.5989C376.378 47.6989 389.678 51.7989 398.378 55.1989C409.978 59.6989 418.378 65.1989 427.178 73.9989C435.978 82.7989 441.278 91.0989 445.978 102.799C449.378 111.599 453.478 124.899 454.578 149.199C455.778 175.499 456.078 183.399 456.078 250.199C456.078 316.999 455.778 324.899 454.578 351.199C453.478 375.599 449.378 388.899 445.978 397.599C441.478 409.199 435.978 417.599 427.178 426.399C418.378 435.199 410.078 440.499 398.378 445.199C389.578 448.599 376.278 452.699 351.978 453.799C325.678 454.999 317.778 455.299 250.978 455.299C184.178 455.299 176.278 454.999 149.978 453.799C125.578 452.699 112.278 448.599 103.578 445.199C91.9783 440.699 83.5783 435.199 74.7783 426.399C65.9783 417.599 60.6783 409.299 55.9783 397.599C52.5783 388.799 48.4783 375.499 47.3783 351.199C46.0783 324.899 45.8783 316.899 45.8783 250.199Z",
    fill: "url(#paint2_linear_11181_233267)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11181_233267",
    x1: 423.516,
    y1: 38.6017,
    x2: 62.1317,
    y2: 481.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE3DAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0468721,
    stopColor: "#B23BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#BD368E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2148,
    stopColor: "#CE2E69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#E62335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#FF1800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11181_233267",
    x1: 312.013,
    y1: 147.216,
    x2: 180.752,
    y2: 367.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12F6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    stopColor: "#EA3751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3563,
    stopColor: "#F13D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5467,
    stopColor: "#F64133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    stopColor: "#F7422F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7946,
    stopColor: "#F74C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    stopColor: "#F7652F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9757,
    stopColor: "#F78F2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79A2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11181_233267",
    x1: 363.999,
    y1: -20.1686,
    x2: 142.932,
    y2: 507.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#9E35A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4512,
    stopColor: "#D42F7F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7524,
    stopColor: "#F7772E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9624,
    stopColor: "#FEF780"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11181_233267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    transform: "translate(0.77832 0.198975)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/Instagram_logo.f063d121d1ff1f841491bd5034fa4eff.svg";
export { ForwardRef as ReactComponent };